import { UserIcon } from "lucide-react";
import React, { useState } from "react";
import { Modal } from "../../../components/ui/Modal";
import { buildApiUrl } from "../../../lib/utils";
import { User } from "../@types";

interface UserListProps {
  users: User[];
}

export const UserList: React.FC<UserListProps> = ({ users }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!users || users.length === 0) {
    return (
      <div className="flex items-center space-x-2">
        <UserIcon className="w-[30px] h-[30px] text-pColor" />
        <span className="text-hColor">No users</span>
      </div>
    );
  }

  const firstUser = users[0];
  const remainingUsers = users.slice(1);

  return (
    <>
      <div className="flex items-center space-x-3">
        {/* First User Avatar */}
        {firstUser.imageUrl ? (
          <img
            src={buildApiUrl(firstUser.imageUrl)}
            alt={`${firstUser.userName}`}
            className="w-[30px] h-[30px] rounded-full object-cover border border-gray-300 shadow-sm"
          />
        ) : (
          <div className="w-[30px] h-[30px] rounded-full bg-gray-200 flex items-center justify-center border border-gray-300 shadow-sm p-1">
            <UserIcon className="w-full h-full text-hColor" />
          </div>
        )}

        {/* First User Name */}
        <span className="font-medium text-gray-800">{firstUser.userName}</span>

        {/* +X More */}
        {remainingUsers.length > 0 && (
          <button
            onClick={() => setIsModalOpen(true)}
            className="ml-2 text-blue-600 hover:underline text-sm font-medium"
          >
            +{remainingUsers.length} more
          </button>
        )}
      </div>

      {/* Modal for All Users */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="All Users"
        className="max-w-md pb-2"
      >
        <div className="space-y-3 p-6">
          {users.map((user) => (
            <div
              key={user.id}
              className="flex items-center space-x-3 p-2 rounded-md hover:bg-gray-50"
            >
              {user.imageUrl ? (
                <img
                  src={user.imageUrl}
                  alt={user.userName}
                  className="w-10 h-10 rounded-full object-cover border border-gray-300"
                />
              ) : (
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center border border-gray-300">
                  <UserIcon className="w-6 h-6 text-hColor" />
                </div>
              )}
              <span className="text-gray-800 font-medium">{user.userName}</span>
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
};
